import React from 'react';
import {Loader} from "@mantine/core";

const FullHeightLoader = ({message}:{message:string | undefined}) => {
    return (
        <div
            style={{
                textAlign: 'center',
                marginTop: '30%',
                width: '100%',
                height: window.innerHeight * 0.9
            }}
        >
            <Loader />
            <div>{message}</div>
        </div>
    );
};

export default FullHeightLoader;
